'use strict';

import { dataMember, required } from 'santee-dcts';
import { siteDisplayNameRenderer } from '../../renderer/site-display-name-renderer';

export class SponsorStudySite {
    @dataMember()
    @required()
    public siteId: number;

    @required()
    @dataMember()
    public siteNumber: string;

    @required()
    @dataMember()
    public subjectsCount: number;

    @required({nullable : true})
    @dataMember()
    public region: string;

    @required({nullable : true})
    @dataMember()
    public country: string;

    @required()
    @dataMember()
    public isExtremelyLarge: boolean;

    @required({nullable : true})
    @dataMember()
    public investigatorFullName: string;

    public get siteDisplayName(): string {
        return siteDisplayNameRenderer({siteNumber: this.siteNumber, investigatorFullName: this.investigatorFullName});
    }

    @required()
    @dataMember()
    public unreadResultAlertsCount : number;
    
    @required()
    @dataMember()
    public unreadSiteActionsCount : number;
    
    @required()
    @dataMember()
    public unreadSiteCommunications : number;

    public toString() {
        return this.siteDisplayName;
    }
}
